import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import queryClient from '../utilities/queryClient.ts';

const ACTING_AS_ID_KEY = 'ACTING_AS_ID_KEY';

interface IActingAsId {
  actingAsId: number | undefined;
  setActingAsId: (actingAsId: number | undefined) => void;
}

const useActingAsId = create(
  persist<IActingAsId>(
    set => ({
      actingAsId: undefined,
      setActingAsId: (actingAsId: number | undefined) => {
        try {
          const authData = JSON.parse(localStorage.getItem('auth_data')!);
          authData._acting_as_id = actingAsId;
          localStorage.setItem('auth_data', JSON.stringify(authData));
        } catch (err) {}

        queryClient.invalidateQueries({
          refetchType: 'all',
        });

        set({ actingAsId });
      },
    }),
    {
      name: ACTING_AS_ID_KEY,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useActingAsId;
